import AdminSearch from './AdminSearch';
import Provider from './Provider';

export { default as BrandTable } from './BrandTable';
export { default as useBrand } from './useBrand';

const Brands = {
  AdminSearch,
  Provider,
};

export default Brands;
